export function emptyEpisode() {
  return {
    subtitle: null,
    image_key: null,
    file_url: "",
    image: "",
    logo: "",
    logoFile: null,
    duration: 0,
    guid: "",
    size: 0,
    title: "",
    published: true,
    upload_status: "",
    rich_description: null,
    description: "",
    tags: [],
    season: "",
    link: null,
    key: "",
    podcast: "",
    episode: "",
    episode_type: "full",
    author: "",
    explicit: false,
    summary: null,
    publish_date: "",
    duration_hms: "",
    episode_source: "",
    block: false,
  }
}

function initialState() {
  return {
    episodes: null,
    episode: emptyEpisode(),
  }
}

let state = initialState()

export { initialState, state }
